import { CREATE_ABSCHNITT } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateAbschnitt/mutation';
import {
  Mitarbeiter_CreateAbschnittMutation,
  Mitarbeiter_CreateAbschnittMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateAbschnitt() {
  const [execute, result] = useMutation<
    Mitarbeiter_CreateAbschnittMutation,
    Mitarbeiter_CreateAbschnittMutationVariables
  >(CREATE_ABSCHNITT, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const createAbschnitt = useCallback(
    (variables: Mitarbeiter_CreateAbschnittMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createAbschnitt, result] as const;
}
